import { DISPLAY_LANG } from "../config";
import axios from "../axios";

export const getFooterData = async () => {
    const resFooterLabel = await axios.get('footer/footer_labels');
    const resFooterLinks = await axios.get(`footer/footer_links?lang=${DISPLAY_LANG}`);

    return { 
        label: resFooterLabel.data, 
        links: resFooterLinks.data, 
    };
};
